import { commonUri } from "../common";

import { AxiosPromise } from "axios";
import { GenericServices } from "./generic.services";
import Uri from "../common/uri/common-uri.constants";
import CommonUri from "../common/uri/common-uri.constants";
import AutocompleteUri from "../common/uri/autocomplete-uri.constants";
import { IAppointmentPlaceSuggestionParameterModel } from "../models/agenda";
import { ApiResponse } from "../models/app-configuration";
import { IGridConfiguration } from "../models/common/grid-config.model";
import { IAdvanceSearchModel } from "../models/advance-search/AdvanceSearch.model";

import { Oauth2Data } from "../utils/authorization/data-model";
import { LOCALSTORAGE_AUTH2 } from "../common/constants";
import { AI_URI } from "../common/uri/property-uri.constants";
import { LocalStoredOAuthorization2Response } from "../utils/authorization/authorizationFactory";
import { IAiEmailModel } from "../models/common/ai-email.model";
export class CommonServices extends GenericServices {
    constructor() {
        super();
    }

    getPhoneFormat(phoneNumber: string): AxiosPromise<any> {
        let path = encodeURI(commonUri.normalizePhone);
        return this.executeSelecting({ phone: phoneNumber }, path);
    }

    getPlaceSuggestion(
        param: IAppointmentPlaceSuggestionParameterModel,
        isDefault?: boolean
    ) {
        return super
            .executeSelecting(
                param,
                isDefault ? Uri.getAllSuggestPlace : Uri.mapAddress
            )
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return isDefault
                        ? Promise.resolve(response.data)
                        : Promise.resolve(
                            response.data.map(item => item.Description)
                        );
                } else {
                    return Promise.reject(response.message);
                }
            })
            .catch(error => {
                console.log(error, "error");
                return Promise.reject(error);
            });
    }

    getListOfPeople(query: string) {
        return super
            .executeSelectBy({ query }, AutocompleteUri.person)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message);
            })
            .catch(error => {
                console.log(error);
                return Promise.reject(error);
            });
    }

    getMapOptions() {
        return super
            .executeSelecting(undefined, Uri.mapOptions)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message);
            })
            .catch(error => Promise.reject(error));
    }

    getMapRegions(propType?: number) {
        return super
            .executeSelecting({ propType: propType || 1 }, Uri.mapRegions)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message);
            })
            .catch(error => Promise.reject(error));
    }

    getGridConfigs(type?: string) {
        return super
            .executeSelecting(undefined, Uri.getGridConfigs + "/" + type)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(error => Promise.reject(error));
    }

    setGridConfigs(type: string, params: IGridConfiguration) {
        return super
            .executeSelectingPost(params, Uri.getGridConfigs + "/" + type)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(error => Promise.reject(error));
    }

    getCurrentVersion(environment) {
        let url = Uri.getCurrentVersion + "?environment=" + environment || "";
        return super
            .executeSelecting(undefined, url, false)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(error => Promise.reject(error));
    }

    getConsultedNextPerson(payload: { number?: number }) {
        return super.executeSelecting(payload, CommonUri.getConsultedPerson);
    }

    getGridConfigsUsedUsers(type?: string) {
        return super.executeSelecting(
            undefined,
            Uri.getGridConfigsUsedUsers + "/" + type
        );
    }

    globalSearch(payload: { text?: string; group?: boolean; module?: number }) {
        return super.executeSelecting(payload, Uri.globalSearch, false);
    }

    checkStatusBySession(url: string): AxiosPromise<any> {
        return super
            .executeSelecting(undefined, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    restoreObject(objectType: string, request: any): Promise<any> {
        const url = commonUri.restoreObject.replace(":objectType", objectType);
        return this.executePost(request, url)
            .then((response: ApiResponse) =>
                response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message)
            )
            .catch(err => Promise.reject(err));
    }

    getFormDataConfigByType(type: string): Promise<any> {
        let url = commonUri.configFormData.replace(":module", type);

        return this.executeSelecting(undefined, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    getConfigDataByKey({ userConfigKeys, systemConfigKeys }): Promise<any> {
        const url = `${commonUri.getConfigByKey}?UserConfigKeys=${(
            userConfigKeys || []
        ).join(",")}&SystemConfigKeys=${(systemConfigKeys || []).join(",")}`;
        return this.executeSelecting(undefined, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }

    getPrefetchPropertyAgenda(id: number): Promise<any> {
        let url = commonUri.getPrefetchPropertyAgenda.replace(
            ":id",
            id.toString()
        );
        return this.executeSelecting(undefined, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }
    getPrefetchPersonAgenda(id: number): Promise<any> {
        let url = commonUri.getPrefetchPersonAgenda.replace(
            ":id",
            id.toString()
        );
        return this.executeSelecting(undefined, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }

    getUserPhoneDevice() {
        let url = commonUri.getUserPhoneDevice;
        return this.executeSelecting(undefined, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }

    getPersonInfoByPhoneNumber(phoneNumber) {
        let url = commonUri.getPersonInfoByPhone;
        return this.executePost(
            {
                PhoneNumber: phoneNumber
            },
            url
        )
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }
    makeCallWithPhoneNumber(payload) {
        let url = commonUri.makeCallWithPhoneNumber;
        return this.executePost(payload, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }

    getUserPhonePermission() {
        let url = commonUri.phonePermission;
        return this.executePost({ PhoneConfig: true }, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }
    getUserPhoneConfigs() {
        let url = commonUri.phoneConfigs;
        return this.executeSelecting(undefined, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }

    getCallDetailById(id: number) {
        let url = commonUri.callDetail.replace(":id", id.toString());
        return this.executePost(undefined, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }

    getLargeMailingConfigs() {
        let url = commonUri.largeMailingConfigs;
        return this.executePost({}, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }
    getNotificationDetail(customerName: string, trackingTime: string) {
        let url = commonUri.notificationDetail.replace(
            ":customer-name",
            customerName
        );
        return this.executeSelecting(
            {
                trackingTime: trackingTime
            },
            url
        )
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }

    getNotificationPopupDetail(id: number) {
        let url = commonUri.notificationPopupDetail.replace(
            ":id",
            id.toString()
        );
        return this.executeSelecting({}, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }

    sendSMSMessage(data) {
        let url = commonUri.sendSMS;
        return this.executePost(data, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }

    globalSearchAdvance(payload: IAdvanceSearchModel) {
        return this.executePost(payload, commonUri.advanceSearch)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }

    getClientPhoneInfo(PersonIds: any) {
        let url = commonUri.getClientPhoneInfo;
        let ids = PersonIds || [];
        let param = { PersonIds: ids.filter(e => e != null) };

        return this.executePost(param, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }

    translateMultiple(url, sourcelanguage, provider, payload) {
        let authDataStr = localStorage.getItem(LOCALSTORAGE_AUTH2) as any;
        let authData = JSON.parse(authDataStr);
        url = `${url}${commonUri.translateMultiple}?sourcelanguage=${sourcelanguage}&provider=${provider}`;
        url = url.replace(":customer", authData.data.information.customerName);
        return super
            .executeSelectingPost(payload, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {

                    // Support BE translate language to uppercase temporarily
                    response.data.data = response.data.data.map(item => {
                        item.language = item.language.toUpperCase()
                        return item;
                    });

                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(error => {
                return Promise.reject(error);
            });
    }

    getLookupDataSupplier(supplierName, dataTypes) {
        let url = commonUri.getLookupDataSupplier;
        url = url.replace(":supplierName", supplierName);
        url = url.replace(":dataTypes", dataTypes);

        return this.executeSelecting({}, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }

    async *generateAiDescription(payload, type: 'project' | 'property' = 'property') {
        const url = type === 'property' ? AI_URI.DESCRIPTION_GENERATION_STREAM : AI_URI.PROJECT_DESCRIPTION_GENERATION_STREAM;
        const headers = new Headers();
        let auth2 = new LocalStoredOAuthorization2Response();
        let auth2Data = auth2.authorizationData as Oauth2Data;
        if (auth2Data) {
            headers.append(
                "Authorization",
                "Bearer " + auth2Data.oauth2.accessToken
            );
        }

        headers.append("Content-Type", "application/json");

        const response = await fetch(url, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(payload)
        });

        if (response.body) {
            const reader = response.body.getReader();
            const decoder = new TextDecoder();

            try {
                while (true) {
                    const { done, value } = await reader.read();
                    if (done) {
                        yield { isDone: true };
                        return;
                    }
                    // Process the chunk
                    const chunk = decoder.decode(value, { stream: true });
                    yield { chunk, isDone: false };
                }
            } catch (error) {
                console.error("Error reading the stream", error);
            }
        } else {
            console.log("Streaming is not supported by the browser.");
        }
    }

    async generateAiEmail(payload?: IAiEmailModel ) {
        const url = AI_URI.EMAIL_GENERATION;

        try {
            const response: ApiResponse = await super.executePost(payload, url);
            console.log("response", response);
    
            if (response.isSuccess) {
                return response.data;
            } else {
                throw new Error(response.message);
            }
        } catch (error) {
            console.log("error", error);
            throw error;
        }
    }

    getTelSmartRegisterUrl() {
        const url = commonUri.getTelSmartActivateUrl;
        return this.executeSelecting(undefined, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }

    getUnSubscribeTelSmart() {
        const url = commonUri.getUnsubscribeTelSmartUrl;
        return this.executeSelecting(undefined, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }

    getCheckTelSmartStatus() {
        const url = commonUri.getCheckStatusTelSmart;
        return this.executeSelecting({ providers: "telsmart" }, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }

    saveConfigCloudCTI(payload) {
        const url = commonUri.configCloudCTI;
        return this.executePost(payload, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }

    unSubCloudCTI() {
        const url = commonUri.unSubCloudCTI;
        return this.executeSelecting(undefined, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }

    getProviderMakeCall() {
        const url = commonUri.getCheckStatusTelSmart;
        return this.executeSelecting(
            {
                isOnlyWebApp: true
            },
            url
        )
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }
}
